import { useContext, useEffect, useState } from 'react';
import { getPreferenceProperty } from '@wayste/utils';
import invariant from 'ts-invariant';
import { getWaysteContext } from '../context/WaysteContext';
export const FeatureFlags = [
    'wayste-standard',
    'wayste-billing',
    'wayste-commercial',
    'wayste-timetracking',
    'sourgum-marketplace-partner',
];
/**
 *
 * Returns the current account (Hauler) for the logged in user as state.
 * @param override
 * @returns
 */
export function useCurrentAccount(override, usedOutsideOfWayste) {
    const context = useContext(getWaysteContext());
    const client = override || context.client;
    invariant(!!client, 'Could not find "client" in the context or passed in as an option. ' +
        'Wrap the root component in an <WaysteProvider>, or pass an WaysteClient ' +
        'instance in via options.');
    // TODO @luc-anise is there a better way of doing this?
    if (!usedOutsideOfWayste) {
        invariant(!!client.hauler().wayste.currentHauler, 'Could not find "currentHauler" in the hauler service. ' + 'Make sure you are have called the fetch method at least once.');
    }
    const [hauler, setHauler] = useState(client.hauler().wayste.currentHauler);
    const makeFeatureFlags = (hauler) => {
        const flags = [];
        if (!usedOutsideOfWayste) {
            if (!hauler.waysteLite)
                flags.push('wayste-standard', 'wayste-timetracking');
            if (hauler.billingEnabled)
                flags.push('wayste-billing');
            if (getPreferenceProperty(hauler.preferences, 'featureFlagWaysteCommercial'))
                flags.push('wayste-commercial');
            if (hauler.isSourgumPartner)
                flags.push('sourgum-marketplace-partner');
        }
        return flags;
    };
    const [featureFlags, setFeatureFlags] = useState(makeFeatureFlags(hauler));
    useEffect(() => {
        const profileSub = client.hauler().wayste.haulerObservable.subscribe((hauler) => {
            if (!hauler)
                return;
            setHauler(hauler);
            setFeatureFlags(makeFeatureFlags(hauler));
        });
        return () => {
            profileSub.unsubscribe();
        };
    }, [client, hauler]);
    return {
        hauler,
        featureFlags,
        refresh: client.hauler().wayste.fetch,
    };
}
//# sourceMappingURL=useCurrentAccount.js.map